import { createFileRoute, Link } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { WBSButton } from '@/common/WBSButton';
import FollowUpPartnerDirectoryTable from '@/tables/FollowUpPartnerDirectoryTable';
import { PageContainer } from '~/styles/boardStyles';
import { GroupHeaderWrapper, Title } from '~/styles/layoutElements';

export const Route = createFileRoute('/_app/follow-up-partners/')({
  component: AllPartnersScreen,
});

/**
 * `themes/wbs/buddypress/groups/single/partners/all-partners/all-partners.php`
 * — the coordinator's *All Partners* tab: a heading, one *Add Partner* button
 * (`:11-13`) and the datatable.
 *
 * ONE TITLE WHERE LEGACY RENDERS TWO. Legacy emits an `h3` of the tab label
 * (`:9`) AND a datatable caption of the group name (`base-table.php:4-10` falls
 * through to `the_title()`) — live: *Partners* over *Jena Madeley's Follow-up
 * Coordinator Group*. D24 deleted the group, and the 31 coordinator groups have
 * 31 distinct owners (1:1), so the caption ambiguates nothing by its absence.
 *
 * A bare `Title`, not `TitleWithQuestion`: legacy hangs
 * `wbs_contextual_helper('follow_up_partners')` off this heading (`:9`) and the
 * contextual-help store is not ported — `HelpModal` falls back SILENTLY to its
 * first item on an id miss (`common/HelpModal.tsx:41-46`), so a `?` here would
 * render some other surface's help text. Same call as
 * `follow-up-network.index.tsx:20-23`.
 */
function AllPartnersScreen(): ReactElement {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <GroupHeaderWrapper>
        <Title>{t('wbs.all-partners')}</Title>
        {/* An anchor, as `follow-up-network.index.tsx:24` ships and as legacy's
            own `<a class="button">` is (`all-partners.php:11-13`) — so it is a
            LINK to Playwright, not a button. `data-testid` is there because the
            role is the thing a spec gets wrong. */}
        <WBSButton
          as={Link}
          to="/follow-up-partners/new"
          wide
          data-testid="add-partner"
        >
          {t('actions.add-partner')}
        </WBSButton>
      </GroupHeaderWrapper>
      <FollowUpPartnerDirectoryTable />
    </PageContainer>
  );
}
